import React from 'react';
import { Empty, Timeline, Row, Col } from 'antd';
import { BarcodeOutlined } from "@ant-design/icons"; // เหลือแค่อันนี้ที่ใช้นอก Canvas
import dayjs from 'dayjs';
import 'dayjs/locale/th';

// Import รูปภาพ (ตรวจสอบ Path ให้ถูกต้อง)
import iconReceive from './../icon/รับเข้าระบบ.png';
import iconPending from './../icon/ระหว่างขนส่ง.png';
import iconExport from './../icon/ออกไปนำจ่าย.png';
import iconSuccess from './../icon/นำจ่ายสำเร็จ.png';
import iconUnSuccess from './../icon/นำจ่ายไม่สำเร็จ.png';

const formatThaiDate = (dateStr) => {
    if (!dateStr) return "-";
    const dateObj = dayjs(dateStr, 'DD/MM/YYYY HH:mm:ssZ');
    if (!dateObj.isValid()) return dateStr;
    // ถ้าปีมากกว่า 2400 แสดงว่าเป็น พ.ศ. อยู่แล้ว
    if (dateObj.year() > 2400) {
        return dateObj.format('DD/MM/YYYY HH:mm น.');
    }
    // ถ้าเป็น ค.ศ. ให้แปลงเป็น พ.ศ. (BBBB)
    return dateObj.format('DD/MM/BBBB HH:mm น.');
};

const itemsTemplate = [
    { title: 'รับเข้าระบบ', icon: iconReceive },
    { title: 'ระหว่างขนส่ง', icon: iconPending },
    { title: 'ออกไปนำจ่าย', icon: iconExport },
    { title: 'ผลการนำจ่าย', icon: null },
];

const TrackingDetail = ({ item, index }) => {
    const isSuccess = item.statusCode === '501';
    const statusColor = isSuccess ? '#009b6e' : '#666';

    // แยกวันที่ล่าสุด
    const latestStatus = item.history[0];
    let latestDateObj = { day: '-', monthYear: '-', time: '-', dayName: '-' };

    if (latestStatus?.status_date) {
        let d = dayjs(latestStatus.status_date, 'DD/MM/YYYY HH:mm:ssZ');
        if (d.isValid()) {
            // *** สำคัญ: ถ้าปีเป็น พ.ศ. (มากกว่า 2400) ต้องลบ 543 ก่อนหาชื่อวัน (จันทร์-อาทิตย์) ***
            if (d.year() > 2400) {
                d = d.subtract(543, 'year');
            }

            latestDateObj = {
                dayName: d.format('dddd'), // ชื่อวัน
                day: d.format('DD'),
                month: d.format('MMM'),
                year: d.format('BBBB'), // แสดงปี พ.ศ.
                monthYear: d.format('MMM BBBB'),
                time: d.format('HH:mm น.'),
            };
        }
    }

    if (item.statusCode === '000') {
        return (
            <div id={`capture-node-${index}`} style={{ padding: '20px 30px', backgroundColor: '#fff', fontFamily: 'Sarabun, sans-serif' }}>
                <Empty description="ไม่พบข้อมูลพัสดุในระบบ" />
            </div>
        );
    }

    // เลือกไอคอนสำหรับ Step สุดท้าย
    const deliveryResultIcon = item.statusCode === '401' ? iconUnSuccess : iconSuccess;
    const deliveryResultTitle = item.statusCode === '401' ? 'นำจ่ายไม่สำเร็จ' : 'นำจ่ายสำเร็จ';

    return (
        <div id={`capture-node-${index}`} style={{ padding: '20px 30px', backgroundColor: '#fff', fontFamily: 'Sarabun, sans-serif' }}>
            {/* 1. Header รายละเอียด */}
            <Row gutter={16} style={{ marginBottom: '30px', borderBottom: '1px solid #f0f0f0', paddingBottom: '20px' }}>
                <Col span={6}>
                    <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#333' }}>
                        {item.parcelNo} <span style={{ color: 'red' }}><BarcodeOutlined /></span>
                    </div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{latestStatus?.location || null}</div>
                </Col>
                <Col span={12} style={{ textAlign: 'center' }}>
                    <div style={{ color: statusColor, fontSize: '18px', fontWeight: 'bold' }}>
                        {latestStatus.status_detail}
                    </div>
                    {
                        isSuccess ?
                            <>
                                <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                                    ชื่อผู้รับ : {latestStatus.receiver_name}
                                </div>
                                <div style={{ fontSize: '14px', color: '#666' }}>
                                    สถานะ : {latestStatus?.delivery_description}
                                </div>
                            </>
                            : null
                    }
                </Col>
                <Col span={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <div style={{ textAlign: 'left', color: '#555' }}>
                        <div style={{ fontSize: '14px', marginBottom: '2px', color: '#666' }}>
                            {latestDateObj.dayName}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{
                                fontSize: '20px',
                                fontWeight: 'bold',
                                lineHeight: '0.8',
                                color: '#444',
                                marginRight: '8px'
                            }}>
                                {latestDateObj.day}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#888', lineHeight: '1.2' }}>
                                    {latestDateObj.month}
                                </div>
                                <div style={{ fontSize: '12px', color: '#888', lineHeight: '1.2' }}>
                                    {latestDateObj.year} {latestDateObj.time}
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* 2. Custom Steps (สร้างเองเพื่อคุมเส้นสีแดงได้ 100%) */}
            <div style={{ position: 'relative', padding: '0 20px', marginBottom: '40px' }}>
                {/* เส้นพื้นหลังสีแดง */}
                {/* <div style={{
                    position: 'absolute',
                    top: '25px',
                    left: '45px',
                    right: '45px',
                    height: '3px',
                    backgroundColor: '#ed1c24',
                    zIndex: 0
                }}></div> */}
                <div style={{
                    position: 'absolute',
                    top: '25px',
                    left: '45px',
                    right: '45px',
                    height: '3px',
                    backgroundColor: '#f0f0f0', // สีเทาจางๆ
                    zIndex: 0
                }}></div>
                <div style={{
                    position: 'absolute',
                    top: '25px',
                    left: '45px',
                    // คำนวณ: (100% - 90px) คือความยาวรางทั้งหมด คูณด้วย สัดส่วน step ปัจจุบัน
                    width: `calc((100% - 90px) * ${item.currentStep / (itemsTemplate.length - 1)})`,
                    height: '3px',
                    backgroundColor: '#ed1c24',
                    zIndex: 0,
                    transition: 'width 0.5s ease' // เพิ่ม transition ให้นุ่มนวล
                }}></div>

                {/* ส่วนไอคอน */}
                <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
                    {itemsTemplate.map((step, sIndex) => {
                        let displayIcon = step.icon;
                        let displayTitle = step.title;

                        if (sIndex === 3) {
                            displayIcon = deliveryResultIcon;
                            displayTitle = deliveryResultTitle;
                        }

                        const isPassed = sIndex <= item.currentStep;

                        return (
                            <div key={sIndex} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '80px' }}>
                                <div style={{ backgroundColor: '#fff', borderRadius: '50%', padding: '0 5px' }}>
                                    <img
                                        src={displayIcon}
                                        alt={displayTitle}
                                        style={{
                                            width: '50px',
                                            height: '50px',
                                            objectFit: 'contain',
                                            filter: isPassed ? 'none' : 'grayscale(100%) opacity(0.5)',
                                            transition: 'all 0.3s'
                                        }}
                                    />
                                </div>
                                <div style={{
                                    marginTop: '5px',
                                    fontSize: '14px',
                                    color: isPassed ? '#000' : '#ccc',
                                    textAlign: 'center',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {displayTitle}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* 3. Timeline */}
            <div style={{ overflowY: 'auto', padding: '10px 30px' }}>
                <Timeline
                    items={item.history.map((track, tIndex) => {
                        // const isWarning = track.status === "401";
                        // เลือกรูปภาพที่จะใช้เป็นจุด (Dot)
                        const dotImage = iconSuccess;
                        // const dotImage = isWarning ? iconUnSuccess : iconSuccess;

                        return {
                            color: 'green',
                            // color: isWarning ? 'orange' : 'green',
                            // *** จุดที่แก้ไข: ใช้ <img> แทน Icon SVG เพื่อให้ html2canvas จับภาพได้ ***
                            dot: (
                                <div style={{ backgroundColor: '#fff', borderRadius: '50%', zIndex: 10 }}>
                                    <img
                                        src={dotImage}
                                        alt="status"
                                        style={{
                                            width: '22px',
                                            height: '22px',
                                            display: 'block'
                                        }}
                                    />
                                </div>
                            ),
                            children: (
                                <Row gutter={18} style={{ paddingBottom: '20px' }}>
                                    <Col span={10}
                                        style={{
                                            fontWeight: 'bold',
                                            color: '#555',
                                            fontSize: '14px',
                                            paddingTop: '2px',
                                            textAlign: 'start',
                                            margin: 0
                                        }}>
                                        {formatThaiDate(track.status_date)}
                                    </Col>
                                    <Col span={11} style={{ textAlign: 'start', margin: 0 }}>
                                        <div style={{ fontSize: '14px', color: '#333' }}>
                                            {track.status_detail}
                                            {track.receiver_name ? ` (${track.receiver_name})` : null}
                                            {track.delivery_description ? ` (${track.delivery_description})` : null}
                                        </div>
                                    </Col>
                                    <Col span={3} style={{ textAlign: 'end', margin: 0 }}>
                                        {tIndex === 0 && isSuccess && (
                                            <div style={{ fontSize: '14px' }}>
                                                <a>ลายเซ็น</a> <a>ติดต่อเจ้าหน้าที่</a>
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            )
                        }
                    })}
                />
                {/* CSS เส้นประ */}
                <style>{`
                    .ant-timeline-item-tail { border-left: 2px dashed #009b6e !important; }
                `}</style>
            </div>
        </div >
    );
};

export default TrackingDetail;